import { render, staticRenderFns } from "./Projections.vue?vue&type=template&id=7e643c0a&scoped=true"
import script from "./Projections.vue?vue&type=script&lang=js"
export * from "./Projections.vue?vue&type=script&lang=js"
import style0 from "./Projections.vue?vue&type=style&index=0&id=7e643c0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e643c0a",
  null
  
)

export default component.exports